import { getApiBase } from '../env';

export default function ImageUrl (url) {
    return `${getApiBase()}${url}`
}
